export const get = (name: string) => {
  const value = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
  return value ? value[2] : null;
};

export const set = (name: string, value: string, expiry: number) => {
  const date = new Date();
  date.setTime(date.getTime() + expiry * 60 * 60 * 1000); // 시간 단위로 지정
  document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
};

export const remove = (name: string) => {
  const date = new Date();
  date.setDate(date.getDate() - 1);
  document.cookie = `${name}=;expires=${date.toUTCString()}`;
};
